module.exports = __webpack_public_path__ + "img/04e-Shop_651.b53063ff.jpg";